import { useContext } from 'react';
import { DevToolsContext } from './DevToolsContext';

export const useDevTools = () => {
    const context = useContext(DevToolsContext);
    return context;
};
